import { Component, inject, Input, OnDestroy, Type } from '@angular/core';
import { MatTabLink, MatTabNav, MatTabNavPanel } from '@angular/material/tabs';
import { TooltipComponent } from 'components/shared/tooltip/tooltip.component';
import { Layout } from 'modules/layout';
import { TranslatePipe } from 'pipes/translate.pipe';
import { CredentialService } from 'services/credential.service';
import { NavigationService } from 'services/navigation.service';
import { IconType } from 'components/layout/icon/icon.component';
import { DropdownMenu } from 'components/layout/dropdown-menu/dropdown-menu.component';
import { UserService } from 'services/user.service';

@Component({
	selector: 'shortcut-panel',
	templateUrl: './shortcut-panel.component.html',
	styleUrls: ['./shortcut-panel.component.scss'],
	imports: [Layout, DropdownMenu, MatTabNav, MatTabLink, MatTabNavPanel, TranslatePipe, TooltipComponent]
})
export class ShortcutPanel implements OnDestroy {

	public visibleDropdown?: Shortcut;

	private readonly credentialService = inject(CredentialService);
	private readonly credentialSubscription = inject(UserService).onCredentialsChanged().subscribe(() => { this.setAvailableShortcuts(); });
	private readonly navigationService = inject(NavigationService);

	private _visibleShortcuts: Shortcut[] = [];
	private _allShortcuts: Shortcut[] = [];
	@Input()
	set shortcuts(shortcuts: Shortcut[]) {

		this._allShortcuts = shortcuts;
		this.setAvailableShortcuts();

		const matchesNavigation = (shortcut: Shortcut) => shortcut.component && this.navigationService.activeUrlComponent.constructor.name == shortcut.component.name;
		if (this.navigationService.activeUrlComponent.constructor) {
			this.activeLink = shortcuts.find(s => matchesNavigation(s) || s.children?.find(matchesNavigation));
		}
	}
	get shortcuts() {
		return this._visibleShortcuts;
	}
	activeLink?: Shortcut;

	private setAvailableShortcuts() {
		const shortcutComponents = this._allShortcuts.filter(s => s.component).map(shortcut => shortcut.component!);
		const accessibleComponents = this.credentialService.filterAccessibleComponents(shortcutComponents);
		this._visibleShortcuts = this._allShortcuts.filter(s => !s.component || accessibleComponents.some(component => component == s.component));
	}

	ngOnDestroy() {
		this.credentialSubscription.unsubscribe();
	};
}

export class Shortcut {
	public name = '';
	public icon?: IconType = 'face-raised-eyebrow';
	public description = '';
	public component?: Type<Object>;
	public action?: Function;
	public children?: Shortcut[];

	public setChildren(children: Shortcut[]) {
		this.children = children;
		return this;
	}

	public clickAction() {
		if (this.action != undefined)
			this.action();
	}
}
